import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyCbT9KP1phcVjTLpDTcTgNHMdfiBhjbyRw",
  authDomain: "ultimatesportstore--ddroyal.firebaseapp.com",
  projectId: "ultimatesportstore--ddroyal",
  storageBucket: "ultimatesportstore--ddroyal.appspot.com",
  messagingSenderId: "1033792806768",
  appId: "1:1033792806768:web:f2b95954740b3840ad79b5",
  measurementId: "G-SR3SXHGLV0",
};
  //apiKey: `${process.env.REACT_APP_FIREBASE_KEY}`,
  // authDomain: "idkman2-6afeb.firebaseapp.com",
  // projectId: "idkman2-6afeb",
  // storageBucket: "idkman2-6afeb.appspot.com",
  // messagingSenderId: "422246359678",
  // appId: "1:422246359678:web:ea2696bccedc6203b72e2f",
  // measurementId: "G-2D76606KEH",



// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
